import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import NavbarTop from './components/NavbarTop';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import { CartProvider } from './context/CartContext';
import './style.css';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <CartProvider>
      <Router>
        <div className={`app-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
          <Sidebar isOpen={isSidebarOpen} toggleMenu={() => setIsSidebarOpen(!isSidebarOpen)} />
          <main className="main-content">
            <NavbarTop onMenuClick={() => setIsSidebarOpen(true)} />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
            </Routes>
          </main>

          {/* Mobile Sidebar Overlay */}
          {isSidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setIsSidebarOpen(false)}
              style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 950, backdropFilter: 'blur(5px)'
              }}
            ></div>
          )}
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
